<!--
 * @Author: your name
 * @Date: 2020-05-28 14:14:29
 * @LastEditTime: 2024-06-04 10:21:06
 * @LastEditors: huhu
 * @Description: In User Settings Edit
 * @FilePath: \heshan_web\src\views\overView\omCenter.vue
-->
<template>
  <div class="om_center">
    <div class="map" id="map"></div>
    <div class="deviceList" v-if="showMore">
      <div class="listBox">
        <div class="listT flex  between">
          <span>{{ $t('omcenter.name') }}</span><span>{{ $t('omcenter.address') }}</span>
          <span>{{ $t('realdetile.view') }}</span>
        </div>
        <div class="listM">
          <div class="listMItem flex between" v-for="(item, index) in moreList" :key="'a' + index">
            <span class="listItemName">{{ item.projectName }}</span>

            <span class="listItemAdd">{{ item.address }}</span>
            <span class="hand" @click="seeMore(item)"> {{ $t('realdetile.view') }}>> </span>
          </div>
        </div>
      </div>
    </div>
    <div class="tool_dataList">
      <div class="echarts">
        <div id="echartCity"></div>
      </div>

      <div class="tool_dataListBox row">
        <div class="tool_dataBox">
          <div class="item_imgBox">
            <img src="@/assets/img/omCenter_icon5.png">
          </div>
          <div class="item_text center">{{ $t('omcenter.onlineDev') }}</div>
          <div class="item_text  middle">
            <div class="item_textRow row">
              <div class="item_textColor">{{ info.onlineNum }}</div>
              <div>{{ $t('omcenter.piece') }}</div>
            </div>
          </div>
        </div>
        <div class="tool_dataBox">
          <div class="item_imgBox">
            <img src="@/assets/img/omCenter_icon7.png">
          </div>
          <div class="item_text center">{{ $t('omcenter.offlineDev') }}</div>
          <div class="item_text middle">
            <div class="item_textRow row">
              <div class="item_textColor">{{ info.offlineNum }}</div>
              <div>{{ $t('omcenter.piece') }}</div>
            </div>
          </div>
        </div>
        <div class="tool_dataBox">
          <div class="item_imgBox">
            <img src="@/assets/img/omCenter_icon6.png">
          </div>
          <div class="item_text center">{{ $t('omcenter.devNum') }}</div>
          <div class="item_text middle">
            <div class="item_textRow row">
              <div class="item_textColor">{{ info.totalNum }}</div>
              <div>{{ $t('omcenter.piece') }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="tool_buttonBox">
        <button :class="buttonType=='hide'?'hide_button':'show_button'" @click="buttonChange()">{{buttonLabel}}</button>
      </div> -->
    </div>
    <AlarmPush />
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map'
import AlarmPush from './alarmPush'
import { mapList, distributionData, stateData } from '@/api/deviceOverview/powerStation';
export default {
  name: 'omCenter',
  components: {
    AlarmPush
  },
  data() {
    return {
      dataList: {},
      buttonType: 'hide', //显示或隐藏按钮类型
      buttonLabel: this.$t('omcenter.hideDevName'),
      map: null,
      arr: [],
      contactData: [],
      provinceList: [],
      info: {},
      moreList: [],
      showMore: false
    }
  },
  mounted() {
    this.showMap()
    this.showDistributionData()
    this.showStateData()

  },
  created() {
  },
  methods: {
    seeMore(obj) {
      // this.$store.dispatch('SetDefaultStationFun', obj).then(res => {

      // })
      // .catch(() => {});
      this.$router.push({ path: '/comlpexManage/fileManage', query: { id: obj.projectName } })
    },
    // 显示或隐藏配电站名称按钮
    buttonChange() {
      var markers = this.map.getOverlays();
      if (this.buttonType == 'hide') {
        this.buttonType = 'show'
        this.buttonLabel = this.$t('omcenter.showDevName')
        // 隐藏文字标签
        for (var i = 0; i < markers.length; i++) {
          if (markers[i].toString() == "[object Marker]") {     //调用getLabel()前需判断overlays类型
            markers[i].getLabel().hide();
          }
        }
      } else {
        this.buttonType = 'hide'
        this.buttonLabel = this.$t('omcenter.hideDevName')
        // 显示文字标签
        for (var i = 0; i < markers.length; i++) {
          if (markers[i].toString() == "[object Marker]") {
            markers[i].getLabel().show();
          }
        }
      }
    },
    drawBarChart(id, options) {
      console.log(options, 'optionss-')
      let myChart = echarts.init(document.getElementById(id));
      // 使用 aidState做填充，fakeState显示小线条
      myChart.showLoading({
        text: this.$t('alarmData.loading') + '...'
      });
      myChart.hideLoading();
      myChart.setOption(options, (window.onresize = myChart.resize));
    },
    // 调用接口
    // 显示地图

    showMap() {
      let _this = this
      mapList().then(res => {
        console.log(res)
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          return;
        }
        const { data } = res.data
        data.map(item => {
          if (item.location) {
            item.location = JSON.parse(item.location)
          }

          // item.location.lat = item.location.lat.toString().slice(0,7)
          // item.location.lon = item.location.lon.toString().slice(0,8)
        })

        let arr = []
        data.map(item => {
          let obj = {}
          if (item.location) {
            obj = item.location;
          }
          if (item.onlineFlag) {
            obj.onlineFlag = item.onlineFlag
          }

          let filterIndex = arr.findIndex(item => {
            // console.log(item, obj,'item--obj')
            return ((item.lat == obj.lat) && (item.lon == obj.lon))
          })
          // console.log(filterIndex)&& filterIndex == -1
          if (!obj.list) {
            obj.list = []
            obj.list.push(item)
          } else {
            arr[filterIndex].list.push(item)
          }
          arr.push(obj)
        })
        this.arr = arr



        let contactData = [], defaultMore = []
        this.arr.forEach(item => {
          // console.log(item,'itemitem')
          let itemlat = ''
          let itemlon = ''
          if (item.lat) {
            itemlat = item.lat.toString().slice(0, 7)
          }
          if (item.lon) {
            itemlon = item.lon.toString().slice(0, 8)
          }

          // let itemlon = item.lon.toString().slice(0,8)
          let findIndex = -1
          findIndex = contactData.findIndex(key => {
            return (key.lat == itemlat) && (key.lon == itemlon)
          })

          defaultMore.push(item.list[0])
          if (!contactData.length) {
            contactData.push({
              lat: itemlat,
              lon: itemlon,
              list: [item.list[0]]
            })
          } else if (findIndex > -1) {
            contactData[findIndex].list.push(item.list[0])

          } else {
            contactData.push({
              lat: itemlat,
              lon: itemlon,
              list: [item.list[0]]
            })
          }
        });
        this.contactData = contactData
        if (defaultMore.length) {
          this.showMore = true

          this.moreList = defaultMore
        }
        console.log(this.arr, defaultMore, ' this.arry')

        this.map = new BMap.Map("map"); // 创建Map实例
        this.map.reset()
        this.map.centerAndZoom(new BMap.Point(this.arr[0].lon, this.arr[0].lat), 8); // 初始化地图,设置中心点坐标和地图级别
        this.map.enableScrollWheelZoom(true);//启用滚轮放大缩小
        this.map.setCurrentCity(this.$t('omcenter.inChina')); // 设置地图显示的城市 此项是必须设置的
        let clusterMarkers = []

        var markers = [];
        var pt = null;

        for (let i = 0; i < this.arr.length; i++) {
          if (!this.arr[i].list) {
            continue
          }
          var point = new BMap.Point(this.arr[i].lon, this.arr[i].lat);
          let index = this.arr[i].onlineFlag * 1
          var myIcon = new BMap.Icon(require('@/assets/img/map_icon1.png'), new BMap.Size(47, 49))
          var marker = new BMap.Marker(point, { icon: myIcon })  // 创建标注
          markers.push(marker)
          var label = new BMap.Label(this.arr[i].list.length, { offset: new BMap.Size(40, 8) });
          marker.addEventListener("click", function (e) {
            console.log(e, 'sss')
            _this.showDivBox(_this.arr[i])
          })



          label.setStyle({
            lineHeight: "25px",
            height: "23px",
            color: "white",
            borderRadius: "5px",
            padding: "0 5px",
            background: "RGBA(255, 131, 85, 1)"
          })

        }
        var markerClusterer = new BMapLib.MarkerClusterer(this.map, { markers: markers });

      })
    },
    showDivBox(obj) {
      console.log(obj, '---')
      this.showMore = true
      this.moreList = []
      let ary = []
      let findIndex = -1
      let itemlat = ''
      let itemlon = ''
      if (obj.lat) {
        itemlat = obj.lat.toString().slice(0, 7)
      }
      if (obj.lon) {
        itemlon = obj.lon.toString().slice(0, 8)
      }
      // let itemlat =obj.lat.toString().slice(0,7)
      // let itemlon =obj.lon.toString().slice(0,8)
      findIndex = this.contactData.findIndex(key => {
        return (key.lat == itemlat) && (key.lon == itemlon)
      })
      console.log(findIndex, '===')
      this.moreList = this.contactData[findIndex].list
    },

    // 显示各地城市分布
    showDistributionData() {
      distributionData().then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.provinceList = res.data.data
          let xAxisAry = [], serialAry = []
          for (let i = 0; i < this.provinceList.length; i++) {
            xAxisAry.push(this.provinceList[i].province)
            serialAry.push(this.provinceList[i].projectCount)
          }
          let options = {
            title: {
              subtext: this.$t('omcenter.devPlace'),
            },
            color: '#6395f9',
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: xAxisAry,
              minInterval: 1,
            },
            series: [

              {
                name: '',
                type: 'bar',
                barWidth: 15,
                data: serialAry
              }
            ]
          };

          this.drawBarChart('echartCity', options)
        } else {
          this.$message.error(res.data.msg);
          return;
        }
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 显示右侧工具栏数据
    showStateData() {
      stateData().then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.info = res.data.data
        } else {
          this.$message.error(res.data.msg);
          return;
        }
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
.echarts {
  height: 72%;
}

#echartCity {
  width: 90%;
  height: 100%;
  margin: 0 5%;
}

.om_center {
  width: 100%;
  padding: 0 !important;
  height: 100%;
  position: relative;

  .map {
    height: 100%;

    .BMap_cpyCtrl {
      display: none;
    }

    .anchorBL {
      display: none;
    }
  }

  .deviceList {
    width: 25%;
    height: 30%;
    position: absolute;
    right: 1.5%;
    top: 5%;
    overflow-y: auto;
    background-color: rgba($color: #000000, $alpha: 0.7);
    border-radius: 10px;
    color: #fff;

    .listBox {
      padding: 10px;

      .listT {
        display: flex;

        span {
          flex: 1;
          text-align: center;
        }
      }

      .listT,
      .listMItem {
        font-size: 14px;
        line-height: 2;
      }

      .itemStatus {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: inline-block;
      }

      .status0 {
        background: #8a8a8a;
      }

      .status1 {
        background: #1afa29;
      }
    }
  }

  .tool_dataList {
    flex-wrap: wrap;
    width: 25%;
    height: 45%;
    position: absolute;
    right: 1.5%;
    top: 40%;
    background-color: white;
    border-radius: 10px;

    .tool_dataListBox {
      height: 86%;
      margin-top: 2%;

      .tool_dataBox {
        width: 33%;
        height: 25%;

        .item_imgBox {
          margin: 0 auto;
          height: 55%;
          width: 40%;
          display: block;
          position: relative;

          // background: url('~@/assets/img/omCenter_icon1.png') no-repeat;
          // background-position-x: center;
          // background-size: contain;
          img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate3d(-50%, -50%, 0);
          }
        }

        .item_text {
          font-size: 12px;
          white-space: nowrap;

          .item_textRow {
            display: inline;

            .item_textColor {
              font-size: 14px;
              display: inline;
              color: RGBA(255, 131, 85, 1);
            }

            div {
              display: inline;
            }
          }
        }
      }
    }

    .tool_buttonBox {
      display: flex;
      height: 9%;
      margin-bottom: 1%;
      align-items: center;
      justify-content: center;

      button:focus {
        border: 0;
        outline: 0;
      }

      button {
        cursor: pointer;
        width: 70%;
        text-align: center;
        padding: 2.3%;
        border: 0;
        border-radius: 5px;
        color: white;
      }

      .show_button {
        border: RGBA(1, 170, 167, 1);
        background-color: RGBA(1, 170, 167, 1);
      }

      .hide_button {
        border: RGBA(255, 131, 85, 1);
        background-color: RGBA(255, 131, 85, 1);
      }
    }
  }
}

.listItemName,
.listItemAdd {
  width: 90px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ;
  ;
}
</style>
